import { makeAutoObservable } from 'mobx';
import { HealthDataPointType } from './HealthDataPointType';
import { HttpBackend } from '../../Services/Http/HttpBackend';
import { HealthDataPointSource, createHealthDataPointSource } from './HealthDataPointSource';
import { Audited, createAuditedFields } from '../Audited';

// Observable model type
export type HealthDataPoint = Audited & {
  pointType: HealthDataPointType;
  startDate: string;
  endDate: string;
  source?: HealthDataPointSource;
  save(): Promise<HealthDataPoint>;
  update(): Promise<any>;
};

// Factory function
export function createHealthDataPoint(json?: Partial<HealthDataPoint>): HealthDataPoint {
  return makeAutoObservable({
    ...createAuditedFields(json),
    pointType: json?.pointType ?? HealthDataPointType.quantity,
    startDate: json?.startDate ?? new Date().toISOString(),
    endDate: json?.endDate ?? new Date().toISOString(),
    source: json?.source ? createHealthDataPointSource(json.source) : undefined,

    save(): Promise<HealthDataPoint> {
      return HttpBackend.post(`/athlete/health-data`, this)
        .then((result) => {
          this.id = result.id || this.id;
        })
        .then(() => this);
    },

    update() {
      return HttpBackend.put(`/athlete/health-data/${this.id}`, this);
    },
  });
}
